
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            id: Number
        },
        data() {
            return {
                isLoading: true as boolean,
                Parameters: [{
                    name: 'ID',
                    value: this.id == null || this.id <= 0 ? history.state.paymentID : this.id,
                }] as Array<object>,      
                ReportServer: window.location.origin + '/PayTickets/api' as string,
                ControllerAction: '/Report/GetReceiptReportAction' as string
            }
        },
        computed: {
            actionComputed(): string {
                return `${this.ReportServer}${this.ControllerAction}`;
            }
        },
        methods: {

            loadView(): void {
                let form = ((this.$refs as any).reportFrameParameters as HTMLFormElement);

                var zoomLevel = "?#zoom=75";

                if (screen.width <= 1024) {
                    zoomLevel = "?#zoom=60";
                } else if (screen.width <= 1366) {
                    zoomLevel = "?#zoom=58";
                }
                form.action += zoomLevel;
                form.submit();

                ((this.$refs as any).reportFrame as HTMLFrameElement).style.display = "block";

                ((this.$refs as any).reportFrame as HTMLFrameElement).onload = () => {
                    this.isLoading = false;
                };
            }
        },
        mounted() {
            this.loadView();
        },

    });
